import { render, staticRenderFns } from "./SalePointsDirectory.vue?vue&type=template&id=5ad725bd&scoped=true"
import script from "./SalePointsDirectory.vue?vue&type=script&lang=ts"
export * from "./SalePointsDirectory.vue?vue&type=script&lang=ts"
import style0 from "./SalePointsDirectory.vue?vue&type=style&index=0&id=5ad725bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad725bd",
  null
  
)

export default component.exports